import { render, staticRenderFns } from "./CategoryTopics.vue?vue&type=template&id=be35770c&scoped=true&"
import script from "./CategoryTopics.vue?vue&type=script&lang=js&"
export * from "./CategoryTopics.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTopics.vue?vue&type=style&index=0&id=be35770c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be35770c",
  null
  
)

export default component.exports